// Null/undefined means "unknown" — e.g. older cached responses or BE upstream failure.
// Fail-open so RSVP entry points stay visible until we have positive proof.
//
// The page-list counterpart lives in `rsvpPageVisibility.ts` (`filterRsvpPage`), which folds this
// same flag together with the deadline gate.
export const isRsvpEffectivelyEnabled = (rawRsvpIsEnabled: Maybe<boolean> | undefined, hasEnabledLegacyRsvpQuestions: Maybe<boolean> | undefined): boolean => {
  if (!rawRsvpIsEnabled) {
    return false;
  }
  return hasEnabledLegacyRsvpQuestions !== false;
};
